import { Injectable, ElementRef } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class OverlayService {

	public overlay: ElementRef;
	public overlayMessage: ElementRef;

	hideLoading() {
		this.overlay?.nativeElement.classList.remove('show');
	}
    
	showLoading(message: string | null = null) {
		if (this.overlayMessage?.nativeElement) {
			this.overlayMessage.nativeElement.style = `display: ${message != null ? 'block' : 'none'}`;

			this.overlayMessage.nativeElement.innerHTML = message;
		}

		this.overlay?.nativeElement.classList.add('show');
	}
}
